import IfTestInput from "@/workflow/components/configurations/test-input/content/if";
import { SwitchDetails as SwitchTestInput } from "@/workflow/components/configurations/test-input/content/switch";
import { useUIStore } from "../store/uiStore";
import { useWorkflowStore } from "../store/workflowStore";
import { NodeTypes } from "../types/workflow";

const NodeTestInputModal = () => {
  const { selectedNodeId } = useUIStore();
  const { getNodeById } = useWorkflowStore();
  if (!selectedNodeId) return;
  const node = getNodeById(selectedNodeId);
  if (!node) return;
  console.log(node);
  if (node.data.type === NodeTypes.IF) {
    return <IfTestInput />;
  }

  if (node.data.type === NodeTypes.SWITCH) {
    console.log("prrr");
    return <SwitchTestInput />;
  }

  return null;
};

export default NodeTestInputModal;
